<template>
    <div>
        <SearchCore class="pa3"/>
        <ProjectSearch class="mt3"/>
    </div>
</template>

<script>
import SearchCore from '@/components/global/SearchCore.vue';
import ProjectSearch from '@/components/header/nav-items/search/ProjectSearch.vue';

export default {
    components: {
        SearchCore,
        ProjectSearch
    }
};
</script>
